var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 13.5,
    viewBox: "0 0 15.75 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.125 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.875,4.5H14.569a2.813,2.813,0,0,0-5.512,0H1.125V5.625H9.056a2.813,2.813,0,0,0,5.512,0h2.307ZM11.812,6.75a1.658,1.658,0,0,1-1.688-1.688,1.688,1.688,0,1,1,3.376,0A1.657,1.657,0,0,1,11.812,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.125,13.5H3.431a2.813,2.813,0,0,0,5.512,0h7.932V12.375H8.944a2.813,2.813,0,0,0-5.512,0H1.125Zm5.063-2.25A1.688,1.688,0,1,1,4.5,12.938,1.658,1.658,0,0,1,6.188,11.25Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7481c2c4.svg";
export { ForwardRef as ReactComponent };